import React, { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { ConfirmationModalCDS, ConfirmationModalTestIds } from '@sharedCR/coreDesignSystem/Modals';

import { closeConfirmationDialogAction } from 'store/global/actions';
import { getConfirmationDialogState } from 'store/global/selectors';

const ConfirmationDialog = () => {
  const dispatch = useDispatch();
  const { message, onAccept, onCancel } = useSelector(getConfirmationDialogState);

  const onClose = useCallback(() => {
    dispatch(closeConfirmationDialogAction());
  }, [dispatch]);

  useEffect(() => {
    window.addEventListener('popstate', onClose);

    return () => window.removeEventListener('popstate', onClose);
  }, [onClose]);

  const onAcceptClick = useCallback(
    e => {
      onAccept?.(e);
      onClose();
    },
    [onAccept, onClose],
  );

  const onCancelClick = useCallback(
    e => {
      onCancel?.(e);
      onClose();
    },
    [onCancel, onClose],
  );

  if (!message) {
    return null;
  }

  return (
    <ConfirmationModalCDS
      dataTestId={ConfirmationModalTestIds.MODAL}
      onAcceptClick={onAcceptClick}
      onClose={onCancelClick}
    />
  );
};

export default ConfirmationDialog;
